import React from "react";

const Menu = ({menuItem}) => {

    return (
        <div
            className='w-full h-fms-mobileView-menu-height md:h-fms-menu-height bg-fms-menu-item-background rounded-fms-radius-base md:rounded-fms-radius-xl'>
            <div className='grid grid-cols-5 w-full rtl p-2 md:p-4 justify-center items-center'>
                <div className='text-white space-x-2 space-y-1 md:space-y-6 col-span-3'>
                    <h1 className='text-base md:text-2xl font-bold line-clamp-1'>{menuItem?.Title}</h1>
                    <p className='text-xs md:text-sm line-clamp-2'>{menuItem?.Reception}</p>

                    <div className="border border-white opacity-50"/>

                    {menuItem?.Tags?.length > 0 &&
                    <>
                        <div className='flex justify-between'>
                            {menuItem?.Tags?.map((item) =>
                                <p key={item.id} className='text-xs md:text-light'>{item.text}</p>
                            )}
                        </div>

                        <div className="border border-white opacity-50"/>
                    </>
                    }

                    <div className='flex justify-between w-full'>
                        <div className='flex items-center justify-center'>
                            <h1 className='text-base md:text-3xl'>{menuItem?.Price.split(' ')[0]}</h1>
                            <div className='grid mr-4'>
                                <p className='text-xs md:text-light'>هـزار</p>
                                <p className='text-xs md:text-light'>تومان</p>
                            </div>
                        </div>
                        {menuItem?.Star &&
                        <div className='flex items-center'>
                            <p className='text-sm md:text-2xl opacity-50 ml-4 mt-2'>{menuItem?.Star}</p>
                            <div className='flex w-full h-full items-center'>
                                <img src={require('../resources/icons/starRating.png')}
                                     className='w-fms-icon-width h-fms-icon-height md:w-fms-icon-desktop-width md:h-fms-icon-desktop-height'
                                     alt='rating-icon'/>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                <div className='flex w-full justify-end col-span-2'>
                    <div
                        className='flex max-w-fms-menu-img-mobile-width md:max-w-fms-menu-img-desktop-width max-h-fms-menu-img-mobile-height md:max-h-fms-menu-img-desktop-height rounded-fms-radius-base md:rounded-fms-radius-xl justify-center items-center overflow-hidden'>
                        <img
                            style={{backgroundColor: 'transparent'}}
                            src={menuItem && menuItem.Image ? menuItem.Image : require('../resources/icons/image.jpg')}
                            alt={'icon'} className='object-cover'/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Menu;